<section in:AnimIN out:AnimOUT>
    {#if !$host.state}
        <Loading />
    {:else if $host.state === "PREPARING"}
        <div in:AnimIN out:AnimOUT>
            <div class="panel">
                <div class="info">Atver uz sava telefona</div>
                <div class="caption kvizparty">KVIZ.PARTY</div>
                <div class="info">ievadi kodu</div>
                <h1><Code /></h1>
                {#if extendedPlayers.filter(player => player.mode === "PLAY").length >= 2}
                    {#if watch}
                        <div class="info">Gaidām kad istabas izveidotājs sāks spēli!</div>
                    {:else}
                        <StartGameButton on:click={startGame} />
                    {/if}
                {:else}
                    <div class="info">Nepieciešami vismaz divi spēlētāji!</div>
                {/if}

                <div class="profile">
                    {#each extendedPlayers.filter(player => player.mode === "PLAY") as player}
                        <ProfileIcon profile={player} />
                    {/each}
                </div>
            </div>
        </div>    
    {:else}
        <div class="code" in:AnimIN out:AnimOUT>
            <span class="caption">KVIZ.PARTY</span>
            <Code />
        </div>

        <div class="game" in:AnimIN out:AnimOUT>
            <div class="profile">
                {#each extendedPlayers.filter(player => player.mode === "PLAY") as player}
                    <ProfileIcon profile={player} />
                {/each}
            </div>
        
            {#if $host.state === "QUESTIONING"}
                <div in:AnimIN out:AnimOUT>
                    <Question />
                </div>
            {:else}
                <div class="vote-split" in:AnimIN out:AnimOUT>
                    <div in:AnimIN out:AnimOUT>
                        <Question />
                    </div>
                    
                    {#if $host.state === "VOTING"}
                        <div in:AnimIN out:AnimOUT>
                            {#each $host.cards as card, i}
                                <Option players={$host.players} char={options[i]} {card} />
                            {/each}
                        </div>
                    {/if}

                    {#if $host.state === "VOTE_RESULTS"}
                        <div in:AnimIN out:AnimOUT>
                            {#each $host.cards as card, i}                            
                                <Result players={$host.players} char={options[i]} {card} />
                            {/each}
                        </div>
                    {/if} 
                </div>
            {/if}
        </div>
    {/if}
    
    <BackButton on:click={back} />
</section>

<style>
.kvizparty {
    font-size: 4.2em;
    color: white;
}
.profile {
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.panel{
    text-align: center;
}
.info{
    font-size: 1em;
    margin-top: 2em;
    margin-bottom: 2em;
}
.game {
    width: 80%;
    margin-top: -100px;
}
.vote-split {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.code {
    position: absolute;
    top: 0px;
    left: 30px;
    font-size: 0.5em;
    color: #fff;
    background-color: var(--tera);
    border-radius: 0px 0px 50px 50px;
    padding: 10px 20px;
    padding-bottom: 20px;
}
.code span {
    text-align: center;
    font-size: 2em;
    display: block;
    font-weight: 800;
    color: var(--kilo);
}
</style>

<script>
import { AnimIN, AnimOUT } from "../../code/anim.js"

import Loading from "../../layout/Loading.svelte"
import StartGameButton from "../../components/buttons/StartGame.svelte"
import BackButton from "../../components/buttons/Back.svelte"
import ProfileIcon from "../../components/player/Icon.svelte"
import Result from "./parts/Result.svelte"
import Option from "./parts/Option.svelte"

import Question from "./parts/Question.svelte"
import Code from "./parts/Code.svelte"

import { restartDefault } from "../../stores/join"
import { host, cards } from "../../stores"

export let socket
export let watch

const options = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'X', 'V', 'Z']

const back = () => {    
    socket.emit('leaveRoom')
    restartDefault()
}

let extendedPlayers = []
let playersLoaded = false

const hasDoneMove = player => {
    switch ($host.state) {
        case "QUESTIONING":
            return $host.cards.some( card => card.userId === player.id )
        break
        case "VOTING":
            return $host.cards.some(({ voters }) => voters.some(uid => uid === player.id))
        break
        case "VOTE_RESULTS":
            return player.ready > 0
        break
        default:
            return false;
    }
}

$: if($host.state) extendedPlayers = $host.players.map( player => ({
    ...player,
    pickedCard: hasDoneMove(player)
}) )

const startGame = () => {
    socket.emit('startGame')
}
</script>